export default __webpack_public_path__ + "static/media/icon_simpro_invoice.92d2d47a.svg";